import { lazy } from "react";
export { default as SiteHeader } from "./SiteHeader";

export const AccordionItem = lazy(() => import("./AccordionItem"));
export const BackLink = lazy(() => import("./BackLink"));
export const BlockQuoteCard = lazy(() => import("./BlockQuoteCard"));
export const BlogFeedCard = lazy(() => import("./BlogFeedCard"));
export const Body = lazy(() => import("./Body"));
export const BranchDirections = lazy(() => import("./BranchDirections"));
export const BranchLocationCard = lazy(() => import("./BranchLocationCard"));
export const BranchLocator = lazy(() => import("./BranchLocator"));
export const BranchMap = lazy(() => import("./BranchMap"));
export const CaseStudyCard = lazy(() => import("./CaseStudyCard"));
export const CollapsibleSectionItem = lazy(() => import("./CollapsibleSectionItem"));
export const Content = lazy(() => import("./Content"));
export const CTA = lazy(() => import("./CTA"));
export const Description = lazy(() => import("./Description"));
export const Detail = lazy(() => import("./Detail"));
export const DynamicHtml = lazy(() => import("./DynamicHtml"));
export const DynamicText = lazy(() => import("./DynamicText"));
export const DynamicContent = lazy(() => import("./DynamicContent"));
export const FeaturedEmployerCard = lazy(() => import("./FeaturedEmployerCard"));
export const Form = lazy(() => import("./Form"));
export const GoogleJobsSchema = lazy(() => import("./GoogleJobsSchema"));
export const GridButton = lazy(() => import("./GridButton"));
export const HeroCarouselCard = lazy(() => import("./HeroCarouselCard"));
export const Image = lazy(() => import("./Image"));
export const JobCard = lazy(() => import("./JobCard"));
export const LatestBlogCard = lazy(() => import("./LatestBlogCard"));
export const LogoCard = lazy(() => import("./LogoCard"));
export const MiniCarouselCard = lazy(() => import("./MiniCarouselCard"));
export const MultiTileCard = lazy(() => import("./MultiTileCard"));
export const MultiCard = lazy(() => import("./MultiCard"));
export const NoSSR = lazy(() => import("./NoSSR"));
export const Phone = lazy(() => import("./Phone"));
export const Email = lazy(() => import("./Email"));
export const PromoButton = lazy(() => import("./PromoButton"));
export const PromoItem = lazy(() => import("./PromoItem"));
export const PromotionalCarouselItem = lazy(() => import("./PromotionalCarouselItem"));
export const PromotionalPanelCard = lazy(() => import("./PromotionalPanelCard"));
export const ReciteMeWidget = lazy(() => import("./ReciteMeWidget"));
export const RecruiterListingItem = lazy(() => import("./RecruiterListingItem"));
export const RelatedArticleCard = lazy(() => import("./RelatedArticleCard"));
export const RelatedArticles = lazy(() => import("./RelatedArticles"));
export const RelatedJobCard = lazy(() => import("./RelatedJobCard"));
export const SidebarNavigation = lazy(() => import("./SidebarNavigation"));
export const SimilarJobCard = lazy(() => import("./SimilarJobCard"));
export const SiteFooter = lazy(() => import("./SiteFooter"));
export const SocialLinks = lazy(() => import("./SocialLinks"));
export const SocialNavigation = lazy(() => import("./SocialNavigation"));
export const SocialShare = lazy(() => import("./SocialShare"));
export const Tag = lazy(() => import("./Tag"));
export const Time = lazy(() => import("./Time"));
export const Title = lazy(() => import("./Title"));
export const Video = lazy(() => import("./Video"));
export const VideoModal = lazy(() => import("./VideoModal"));
